import React, { useState } from 'react';
import { resetPassword } from '../api';

// Палітра з Figma (та сама, що в Login.js).
const C = {
  bg: '#F9FAFB', card: '#FFFFFF', border: '#E5E7EB', title: '#101828',
  text: '#4A4D61', placeholder: '#9CA3AF', accent: '#475FFA',
};
const FONT = "'Inter', 'Segoe UI', system-ui, sans-serif";
const CONTENT = 360;

const S = {
  root: {
    minHeight: '100vh', background: C.bg, fontFamily: FONT, position: 'relative',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '88px 24px 48px', boxSizing: 'border-box',
  },
  brand: { position: 'absolute', top: 24, left: 32, display: 'flex', alignItems: 'flex-end', gap: 11 },
  card: {
    background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 40,
    boxShadow: '0px 14px 26px 0px rgba(0,0,0,0.04)', boxSizing: 'content-box',
    width: CONTENT, maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: 24,
  },
  title: { fontSize: 24, fontWeight: 600, color: C.title, margin: 0 },
  subtitle: { fontSize: 14, color: C.text, marginTop: 8 },
  label: { display: 'block', fontSize: 14, fontWeight: 500, color: C.title, marginBottom: 6 },
  input: (f) => ({
    width: '100%', height: 48, padding: '0 14px', background: C.card,
    border: `1px solid ${f ? C.accent : C.border}`, borderRadius: 12, color: C.title,
    fontSize: 14, fontFamily: FONT, outline: 'none', boxSizing: 'border-box', transition: 'border-color .15s',
  }),
  hint: { fontSize: 12, color: C.placeholder, marginTop: 6 },
  btn: (loading) => ({
    width: '100%', height: 48, background: C.accent, border: 'none', borderRadius: 12,
    color: '#fff', fontSize: 16, fontWeight: 500, fontFamily: FONT,
    cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
  }),
  link: { fontSize: 13, fontWeight: 600, color: C.accent, cursor: 'pointer', textAlign: 'center' },
  error: { background: '#FEE2E2', border: '1px solid #FB2C36', borderRadius: 12, color: '#FB2C36', fontSize: 13, padding: '10px 14px' },
  notice: { background: '#DCFCE7', border: '1px solid #00A656', borderRadius: 12, color: '#0a7a44', fontSize: 13, padding: '10px 14px' },
};

function getToken() {
  try { return new URLSearchParams(window.location.search).get('token') || ''; }
  catch { return ''; }
}

export default function ResetPassword({ onLogin }) {
  const [token]                 = useState(getToken);
  const [password,  setPassword]  = useState('');
  const [password2, setPassword2] = useState('');
  const [error,     setError]     = useState('');
  const [done,      setDone]      = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [focusKey,  setFocusKey]  = useState('');

  const goLogin = () => { window.location.href = '/login'; };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Пароль має бути не коротшим за 6 символів'); return; }
    if (password !== password2) { setError('Паролі не співпадають'); return; }

    setLoading(true);
    try {
      const res = await resetPassword({ token, password });
      // Бекенд одразу видає токен → автологін.
      if (res.data.token && onLogin) {
        onLogin(res.data.token, res.data.username, res.data.role || 'user');
        return;
      }
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Не вдалося скинути пароль. Запросіть нове посилання.');
    } finally {
      setLoading(false);
    }
  }

  const inputProps = (key) => ({
    style: S.input(focusKey === key),
    onFocus: () => setFocusKey(key),
    onBlur:  () => setFocusKey(''),
  });

  return (
    <div style={S.root}>
      <a href="/" style={{ ...S.brand, textDecoration: 'none' }}>
        <img src="/images/auth/brand-icon.svg" alt="" style={{ width: 32, height: 32 }} />
        <img src="/images/auth/logotype.svg" alt="Trader" style={{ height: 31 }} />
      </a>

      <div style={S.card}>
        <div>
          <h1 style={S.title}>Новий пароль</h1>
          <div style={S.subtitle}>Придумайте новий пароль для вашого акаунту</div>
        </div>

        {!token ? (
          <>
            <div style={S.error}>Невірне або неповне посилання. Запросіть відновлення паролю ще раз.</div>
            <span style={S.link} onClick={goLogin}>← До входу</span>
          </>
        ) : done ? (
          <>
            <div style={S.notice}>Пароль змінено. Тепер можете увійти з новим паролем.</div>
            <button style={S.btn(false)} onClick={goLogin}>Увійти</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={S.label}>Новий пароль</label>
              <input {...inputProps('p1')} type="password" value={password}
                onChange={e => setPassword(e.target.value)} placeholder="••••••••" autoFocus required />
              <div style={S.hint}>Мінімум 6 символів</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={S.label}>Повторити пароль</label>
              <input {...inputProps('p2')} type="password" value={password2}
                onChange={e => setPassword2(e.target.value)} placeholder="••••••••" required />
            </div>

            {error && <div style={S.error}>{error}</div>}

            <button type="submit" style={S.btn(loading)} disabled={loading}>
              {loading ? '...' : 'Зберегти пароль'}
            </button>
            <span style={S.link} onClick={goLogin}>← Назад до входу</span>
          </form>
        )}
      </div>
    </div>
  );
}
